export default __webpack_public_path__ + "static/media/baby-alien.8af7ebf4.png";